import { bindConnect } from '../../utils';
import NewsList from './NewsList.js';

export default bindConnect((state, props) => ({
  user: state.current_user.user,
  siteId: props.siteId
}), {
})(NewsList);
